export default __webpack_public_path__ + "static/media/failed.c1fbc5ad.svg";